import React, { useEffect, useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { NavLink, useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import { useSelector } from "react-redux";
import { avantSolarApi } from "api/authApi";
import Select from "react-select";
import BarchartInfoCliente from "components/chart/BarChartInfoCliente";
import BarchartLecturas from "components/chart/BarChartLecturas";
import Footer from "components/Footer/Footer";
import { log } from "util";
import { Spinner } from "reactstrap";
import SpinnerAvantsolar from "components/utils/spinner";

var ps;

function obtenerNumero(cadena) {
  // Usamos una expresión regular para buscar el número seguido de un espacio en la cadena
  const match = cadena.match(/\d+/);

  if (match) {
    // Si se encuentra el número, lo convertimos a un número entero
    const numero = parseInt(match[0], 10);
    return numero;
  } else {
    // Si no se encuentra un número, podemos manejarlo como desees
    return null;
  }
}

const scrollToTop = () => {
  const contenedor = document.querySelector(".main-panel");
  contenedor.scrollTop = 0;
};

function GraficasLectura(props) {
  const mainPanel = React.useRef();
  const location = useLocation();
  const [datos, setDatos] = useState([]);
  const [datosCopy, setDatosCopy] = useState([]);
  const { jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);

  React.useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current);
    document.body.classList.toggle("perfect-scrollbar-on");

    const contenedor = document.querySelector(".main-panel");
    contenedor.onscroll = function () {
      let contenedorY = contenedor.scrollTop;
      setIsActive((prevIsActive) => {
        const newIsActive = contenedorY > 600;
        return newIsActive !== prevIsActive ? newIsActive : prevIsActive;
      });
    };

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  }, []);

  const isActiveMemoized = React.useMemo(() => isActive, [isActive]);

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  let est = 0.95;

  useEffect(() => {
    fetchGraficas();
  }, [huerta]);

  const orderTableColumn = (prop) => {
    let Sort = [...datosCopy];
    if (prop != "nombreTitular") {
      Sort.sort(function (a, b) {
        if (obtenerNumero(a[prop]) < obtenerNumero(b[prop])) {
          return -1;
        }
        if (obtenerNumero(a[prop]) > obtenerNumero(b[prop])) {
          return 1;
        }
        return 0;
      });
    } else {
      Sort.sort(function (a, b) {
        if (a.titular[prop] < b.titular[prop]) {
          return -1;
        }
        if (a.titular[prop] > b.titular[prop]) {
          return 1;
        }
        return 0;
      });
    }

    setDatos([...Sort]);
  };

  const fetchGraficas = async () => {
    setError(null);
    setLoading(true);
    try {
      const response = await avantSolarApi.get(
        "/admins/readingsGraphic?id_huerta=" + huerta,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;
      setLoading(false);

      if (data?.code == 200) {
        setDatos(data.data);
        setDatosCopy([...data.data]);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error.response.data.message);
    }
  };

  const options = [
    { value: "nombreInstalacion", label: "Instalacion" },
    { value: "potencia", label: "Potencia" },
    { value: "nombreTitular", label: "Titular" },
  ];

  const handleChangeSelect = (event) => {
    orderTableColumn(event.value);
  };

  return (
    <div className="wrapper">
      <Sidebar {...props} routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <div>
          <DemoNavbar {...props} />
          <div className="p-2">
            <div className="d-flex align-items-center justify-content-center mb-3">
              <span>Ordenar por:</span>
              <Select
                className="w-50 ml-2"
                defaultValue={options[0]}
                options={options}
                onChange={handleChangeSelect}
              />
            </div>
            {isActiveMemoized && (
              <div
                onClick={scrollToTop}
                className={`d-flex justify-content-end pr-4 fixed-bottom `}
              >
                <span className="mdi mdi-arrow-up-bold h2 bg-dark text-white rounded">
                  {" "}
                </span>
              </div>
            )}
            {loading && <SpinnerAvantsolar />}
            {datos.map((dato, i) => {
              return (
                <div key={i} className=" m-1 mb-5 p-2">
                  <div className="d-flex bg-white px-5-xl px-2 py-2 rounded">
                    {dato.nombreInstalacion}
                    {" - " + dato.potencia + " - "}
                    <NavLink to={`/informacioncliente/${dato.titular.dni}`}>
                      <p className="pointer ml-1 text-blue">
                        {" "}
                        {dato.titular.nombreTitular}
                      </p>
                    </NavLink>
                  </div>

                  <BarchartLecturas dataGrafica={dato.lecturas} />
                </div>
              );
            })}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default GraficasLectura;
